<template>
  <div class="register">
    <v-stepper v-model="step">
      <v-stepper-items>
        <v-stepper-content step="1" class="pa-0">
          <v-card class="py-8 px-10">
            <h3 class="mb-6 text-center">立即註冊</h3>
            <span>Email</span>
            <v-text-field outlined dense :rules="[$rules.email]" v-model="email"></v-text-field>
            <span>密碼</span>
            <v-tooltip bottom nudge-right="120">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="ml-2" v-bind="attrs" v-on="on">fa-question-circle</v-icon>
              </template>
              <span>密碼長度須為 6 到 15 個字元，且包含英文字母及數字</span>
            </v-tooltip>
            <v-text-field outlined dense type="password" :rules="[$rules.password]" v-model="password"></v-text-field>
            <v-row no-gutters>
              <v-col cols="4" class="pr-2">
                <span>姓</span>
                <v-text-field outlined dense :rules="[$rules.notEmpty]" v-model="last_name"></v-text-field>
              </v-col>
              <v-col cols="8" class="pl-2">
                <div class="d-flex justify-space-between mt-1">
                  <span>名</span>
                  <span class="red--text caption ml-auto">(身分審核，需與證件相同)</span>
                </div>
                <v-text-field outlined dense :rules="[$rules.notEmpty]" v-model="first_name"></v-text-field>
              </v-col>
            </v-row>
            <span>暱稱</span>
            <v-text-field outlined dense :rules="[$rules.notEmpty]" v-model="nickname"></v-text-field>
            <span>手機號碼</span>
            <v-text-field outlined dense :rules="[$rules.integer]" v-model="tel" @keydown.enter="register"></v-text-field>
            <span>年齡 (選填)</span>
            <v-text-field outlined dense :rules="[rules.age]" v-model="age" @keydown.enter="register"></v-text-field>
            <v-btn dark rounded block height="40" color="pink" class="mt-4" @click="register">下一步</v-btn>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="2" class="pa-0">
          <v-card class="py-8 px-10 verify">
            <h3 class="mb-6 text-center">手機驗證</h3>
            <div class="d-flex align-center mb-6">
              <v-icon class="mr-4 icon">fa-phone-alt</v-icon>
              <div>請輸入 <span class="font-weight-bold">{{ tel }}</span> 收到的6位數驗證碼，驗證碼15分鐘內有效</div>
            </div>
            <span>手機驗證碼</span>
            <div class="code-input">
              <div v-for="(n, i) in 6">
                <input 
                  :ref="`input${i}`" 
                  type="number"
                  @keydown="inputAction(i)" 
                  v-model="code[i]"
                >
              </div>
            </div>
            <v-btn 
              block 
              class="pink white--text mb-2" 
              :disabled="code.join('').length != 6" 
              @click="verifyTel"
            >
              送出
            </v-btn>
            <a @click="!sending ? sendVerifyCode() : ''" :class="['resend', {'not-allow': sending}]">
              <span :class="sending ? 'grey-1--text' : 'pink--text'">重新發送驗證碼 </span>
              <span v-if="sending">({{ time }})</span>
              <v-icon v-else x-small color="pink" class="pl-2">fa-chevron-right</v-icon>
            </a>
          </v-card>
          <!-- <v-card class="py-8 px-10 verify">
            <h3 class="mb-6">檢查您的信箱來驗證 Email</h3>
            <div>我們已經送出一封信件到您的 Email</div>
            <div class="font-weight-bold">{{ email }}</div>
            <div>請檢查您的Email以完成註冊</div>
            <div class="font-weight-bold caption">(檢查垃圾郵件資料夾)</div>
            <v-icon color="indigo">fa-envelope-open-text</v-icon>
            <div>沒有收到驗證信 ?</div>
            <a @click="reSend" v-if="!sending" class="font-weight-regular">重新發送驗證信</a>
            <div v-if="sending">{{ time }}</div>
          </v-card> -->
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  data() {
    return {
      step: 1,
      email: '',
      password: '',
      last_name: '',
      first_name: '',
      nickname: '',
      tel: '',
      age: '',
      code: Array(6).fill(''),
      sending: false,
      time: this.$resendTime,
      rules: {
        age: value => this.$rules.integer(value) || !value
      },
    }
  },
  computed: {
    registerFormIsValid() {
      return (
        this.$rules.notEmpty(this.last_name) &&
        this.$rules.notEmpty(this.first_name) &&
        this.$rules.notEmpty(this.nickname) &&
        this.$rules.email(this.email) &&
        this.$rules.password(this.password) &&
        this.$rules.integer(this.tel) &&
        (this.$rules.integer(this.age) || this.age === '')
      )
    },
    verifyFormIsValid() {
      return this.$rules.integer(this.tel) && this.$rules.notEmpty(this.code.join(''))
    }
  },
  watch: {
    code: {
      handler(newValue) {
        if(newValue.join('').length == 6) {
          this.verifyTel()
        }
      },
      deep: true
    }
  },
  methods: {
    register() {
      if(!this.registerFormIsValid) {
        return
      }
      this.axios.post('/member', {
        email: this.email,
        password: this.password,
        tel: this.tel,
        first_name: this.first_name,
        last_name: this.last_name,
        nickname: this.nickname,
        age: this.age
      }).then(response => {
        let token = `Bearer ${response.data.access_token}`
        this.$store.dispatch('user/setToken', token)
        this.sendVerifyCode()
      }).catch(e => {
        if(e.response) {
          if(e.response.data.message.includes('The email is temporarily used.')) {
            this.$root.$emit('errorDialog', ['該Email已暫時被使用。若您是Email的擁有者，我們已寄送信件到您信箱，請先進行驗證，或稍等1小時再重新進行註冊。'])
          }
          else if(e.response.data.message.includes('The telphone is temporarily used.')) {
            this.$root.$emit('alert', 'error', '該手機號碼已暫時被使用')
          }
          else if(e.response.data.message.includes('The email is used.')) {
              this.$root.$emit('alert', 'error', '該Email已被使用')
          }
          else if(e.response.data.message.includes('The telphone is used.')) {
              this.$root.$emit('alert', 'error', '該手機號碼已被使用')
          }
        }
        else {
          this.$root.$emit('alert', 'error', '註冊失敗')
        }
      })
    },
    sendVerifyCode() {
      this.$store.dispatch('user/sendVerifyTel', this.tel).then(response => {
        this.startTimer()
        this.$root.$emit('alert', 'success', '驗證碼已發送')
        this.step = 2
        this.$nextTick(() => {
          this.code = Array(6).fill('')
          this.input(0).focus()
        })
      }).catch(e => {
        if(e.response) {
          let minute = e.response.data.message.match(/Try again after (\d+) minute/)
          if(minute) {
            this.$root.$emit('alert', 'error', `請${minute[minute.length - 1]}分鐘後再試`)
          }
          else if(e.response.data.message.includes('Please contact our customer service')) {
            this.$root.$emit('alert', 'error', '發送次數過多，請聯繫我們')
          }
        }
        else {
          this.$root.$emit('alert', 'error', '發送失敗')
        }
      })
    },
    startTimer() {
      this.sending = true
      var timer = setInterval(() => {
        this.time -= 1 
        if(this.time < 0) {
          this.time = this.$resendTime
          clearInterval(timer)
          this.sending = false
        }
      }, 1000)
    },
    verifyTel() {
      if(!this.verifyFormIsValid) {
        return
      }
      this.axios.get(`/member/SMS/verify/register?code=${this.code.join('')}`).then(response => {
        this.$store.dispatch('user/getUserInformation')
        this.$root.$emit('alert', 'success', '驗證成功')
        this.$router.push('/')
      }).catch(e => {
        if(e.response) {
          if(e.response.data.message.includes('Code is wrong')) {
            this.$root.$emit('alert', 'error', '驗證碼錯誤')
          }
          else if(e.response.data.message.includes('Code is expired')) {
            this.$root.$emit('alert', 'error', '驗證碼已失效')
          }
        }
        else {
          this.$root.$emit('alert', 'error', '驗證失敗')
        }
        this.code = Array(6).fill('')
        this.input(0).focus()
      })
    },
    input(i) {
      return this.$refs[`input${i}`][0]
    },
    inputAction(e, i) {
      if(this.$numeric.includes(e.keyCode) && this.code.join('').length >= i) {
        this.code.splice(i, 1, e.key)
        this.$nextTick(() => {
          if(this.code.join('').length != 6) {
            this.input(i + 1).focus()
          }
        })
      }
      else if(e.keyCode == 8) {
        if(this.code[i]) {
          this.code.splice(i, 1, '')
        }
        else if(this.code.join('').length) {
          this.code.splice(i - 1, 1, '')
          this.input(i - 1).focus()
        }
      }
      this.$forceUpdate()
      if(!this.$funcKeys.includes(e.keyCode)) {
        e.preventDefault()
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.register {
  font-weight: 400;
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .v-card {
    width: 400px;
    .v-text-field__details {
      display: none;
    }
    span {
      font-size: 12px;
    }
  }
}
</style>